import { useEffect } from 'react';

export const SEOHead = ({ title, description, keywords, image, siteName }) => {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    const setProp = (property, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[property="${property}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('property', property);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);

    // Open Graph / Twitter (client-side; edge function handles crawlers)
    setProp('og:title', title);
    setProp('og:description', description);
    if (siteName) setProp('og:site_name', siteName);
    setProp('og:type', 'website');
    if (typeof window !== 'undefined') setProp('og:url', window.location.href);
    setMeta('twitter:card', image ? 'summary_large_image' : 'summary');
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);
    if (image) {
      setProp('og:image', image);
      setMeta('twitter:image', image);
    }
  }, [title, description, keywords, image, siteName]);

  return null;
};
